<template>
    <div id="app" class="">
        <router-view />
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'App',
    components: {},
    data() {
        return {
            appshow : false,
            username : '',
            menus : [],
            panel : false,
            clsapp : 'main-public',
            // theme : localStorage.theme,
            menuinduk : localStorage.menuinduk
        };
    },
    methods : {
        setMenuInduk(){
            if(this.$route.params.level===0){
                this.menuinduk = this.$route.params.id;
                localStorage.menuinduk = this.menuinduk;
            }
            if(this.$route.params.id === undefined || this.$route.params.id === 'undefined'){
                this.menuinduk = -1;
                localStorage.menuinduk = this.menuinduk;
            }
        }
    },
    watch: {
        '$route': 'setMenuInduk'
    }
}
</script>